import { gql } from '@apollo/client';

export const PATCH_LEARNING_OBJECT_MUTATION = gql`
    mutation patchLearningObject($input: PatchLearningObjectInput!) {
        result: patchLearningObject(input: $input) {
          id
          tags
          format
          duration
          expireAt
          locales {
            locale
            name
            description
          }
          assets {
            edges{
              isDefault
              node {
                id
                name
                url
                mimetype
                encoding
                createdAt
                updatedAt
                locales
              }
            }
          }
          metadata
          createdAt
          updatedAt
          __typename
        }
    }
`;